import React from "react";
import * as Sentry from "@sentry/react";
import { PageError } from "shared/components";

export const ErrorBoundary: React.FC = ({ children }) => (
  <Sentry.ErrorBoundary fallback={PageError}>{children}</Sentry.ErrorBoundary>
);
